import React from 'react';
import { Outlet } from 'react-router-dom';
import Navbar from './Navbar';
import Footer from './Footer';

/**
 * Layout Component
 * 
 * Wraps pages with Navbar and Footer
 * Uses Outlet for nested routes
 */
const Layout = ({ children, hideFooter = false, hideNavbar = false }) => {
  return (
    <div className="min-h-screen flex flex-col bg-gray-50">
      {!hideNavbar && <Navbar />}
      
      <main className="flex-1">
        {children || <Outlet />}
      </main>
      
      {!hideFooter && <Footer />}
    </div>
  );
};

export default Layout;
